import React from 'react';
import { Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ArchitectureCTA() {
  return <section className="pb-0 px-6 md:px-12 lg:px-24 bg-white overflow-hidden" data-id="element-196">
      <div className="max-w-7xl mx-auto border-t border-gray-100 pt-12 md:pt-16" data-id="element-197">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.2fr] gap-16 lg:gap-20" data-id="element-198">
          {/* Left Column: Content */}
          <div className="text-left pb-20 md:pb-24 flex flex-col justify-center" data-id="element-199">
            <span className="text-sm font-bold tracking-widest uppercase text-[#0066FF] mb-6 block font-sans" data-id="element-200">
              Ready to Build?
            </span>

            <h2 className="text-4xl md:text-6xl font-bold mb-8 tracking-tight text-black leading-[1.1] font-['Syne']" data-id="element-201">
              See how your knowledge becomes infrastructure.
            </h2>

            <div className="flex flex-col sm:flex-row items-start gap-6 mt-10" data-id="element-202">
              <Link to="/contact" className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-200 bg-[#0066FF] font-['Syne'] hover:bg-black hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black" data-id="element-203">
                <span data-id="element-204">BOOK A DEMO</span>
                <Calendar className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-205" />
              </Link>
            </div>
          </div>

          {/* Right Column: Large Guardrails Image */}
          <div className="relative w-full h-full flex items-end justify-end pb-0" data-id="element-206">
            <img src="https://cdn.magicpatterns.com/uploads/xe4qKLfDFyZpc9DcsLhfim/guyardrails-instruct.png" alt="Guardrails Interface" className="w-full h-auto object-contain object-bottom" style={{
            minHeight: '600px',
            transform: 'scale(1.3)'
          }} data-id="element-207" />
          </div>
        </div>
      </div>
    </section>;
}